import React from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import SectionTabs, { SectionTab } from '../components/SectionTabs';
import { PageHeader } from '../components/ui';
import { useAuth } from '../context/AuthContext';
import { isAdminUser } from '../utils/authUser';

const TOOL_TABS: SectionTab[] = [
  { id: 'tracking', label: 'Tracking' },
  { id: 'blend-calculator', label: 'Wine Blend Calculator' },
  { id: 'kmbs-calculator', label: 'KMBS Calculator' },
  { id: 'notification-center', label: 'Notification Center' },
];

const DEFAULT_TAB = 'tracking';

/**
 * Groups tracking, calculators, and admin notification tools under one page.
 * Child routes live at /tools/:tabId so Notification Center can keep its own ?tab=.
 */
const ToolsSection: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = isAdminUser(user);

  const tabs = TOOL_TABS.filter((tab) => tab.id !== 'notification-center' || isAdmin);
  const validIds = tabs.map((tab) => tab.id);
  const pathSegment = location.pathname.split('/')[2] || DEFAULT_TAB;

  if (pathSegment === 'notification-center' && !isAdmin) {
    return <Navigate to="/tools/tracking" replace />;
  }

  const activeTab = validIds.includes(pathSegment) ? pathSegment : DEFAULT_TAB;

  const handleTabChange = (id: string) => {
    navigate(`/tools/${id}`);
  };

  return (
    <div className="space-y-7">
      <PageHeader
        title="Tools"
        subtitle="Tracking, blend and SO₂ calculators, and notification admin in one workspace."
      />

      <SectionTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <Outlet />
    </div>
  );
};

export default ToolsSection;
